import { useLocation, useParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Mail, ArrowRight, Home } from "lucide-react";

const formatUSD = (n) =>
  Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

const OrderSuccess = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const result = state?.result;
  const quote = state?.quote;
  const email = state?.email;

  return (
    <div className="min-h-screen relative">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1766040923580-16ad32fae8b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxjYXJkYm9hcmQlMjBib3hlcyUyMHNoaXBwaW5nJTIwd2FyZWhvdXNlfGVufDB8fHx8MTc3NjU1NDMzOHww&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-[color:var(--ups-paper)]/95" />
      <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
        <div className="w-full max-w-xl">
          <div className="card-quote rounded-md p-8 sm:p-10" data-testid="order-success-card">
            <div
              className="w-14 h-14 flex items-center justify-center mb-5"
              style={{ background: "var(--ups-accent)", color: "#fff" }}
            >
              <CheckCircle2 size={28} strokeWidth={2.5} />
            </div>
            <div className="overline mb-2">Order Submitted</div>
            <h1 className="font-display text-4xl sm:text-5xl font-black leading-none tracking-tight">
              We've got it.
            </h1>
            <p className="mt-4 text-sm text-[color:var(--ups-subtext)] leading-relaxed">
              Order <span className="font-mono font-bold text-[color:var(--ups-ink)]">
                #{result?.order_number || orderId?.slice(0, 8).toUpperCase()}
              </span>{" "}
              is in. A confirmation email was sent to you
              {email ? <> at <span className="font-mono">{email}</span></> : null}
              {" "}and the store inbox.
            </p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <div className="p-4 card-swiss rounded-sm">
                <div className="overline mb-1">Email Status</div>
                <div className="flex items-center gap-2 font-mono text-xs">
                  <Mail size={14} />
                  {result?.email_status || "sent"}
                </div>
              </div>
              <div className="p-4 card-swiss rounded-sm">
                <div className="overline mb-1">Attachments</div>
                <div className="font-mono text-xs">
                  {result?.attachments_saved ?? 0} file(s) attached
                </div>
              </div>
            </div>

            {quote && (
              <div className="mt-5 p-4 card-swiss rounded-sm" style={{ borderLeft: "4px solid var(--ups-gold)" }}>
                <div className="overline mb-1">Quoted</div>
                <div className="font-display text-base font-bold">{quote.product_name}</div>
                <div className="flex gap-6 mt-2 text-sm">
                  <div>
                    <div className="text-[11px] uppercase font-bold text-[color:var(--ups-subtext)]">Retail</div>
                    <div className="line-through text-[color:var(--ups-subtext)]">{formatUSD(quote.retail_price)}</div>
                  </div>
                  <div>
                    <div className="text-[11px] uppercase font-bold" style={{ color: "var(--ups-accent)" }}>UPS Store</div>
                    <div className="font-bold" style={{ color: "var(--ups-accent)" }}>{formatUSD(quote.ups_price)}</div>
                  </div>
                </div>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <button
                onClick={() => navigate("/chat")}
                className="btn-brutal flex-1 py-3 px-5 rounded-sm flex items-center justify-center gap-2 text-base"
                data-testid="new-quote-button"
              >
                New Quote <ArrowRight size={18} />
              </button>
              <button
                onClick={() => navigate("/")}
                className="btn-ink flex-1 py-3 px-5 rounded-sm flex items-center justify-center gap-2 text-base"
                data-testid="home-button"
              >
                <Home size={16} /> Exit
              </button>
            </div>
          </div>
          <p className="text-center mt-6 text-[11px] font-mono text-[color:var(--ups-subtext)]">
            UPS Print Hub · Quote Bot v1.0 · Final pricing may vary by store
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
